<template>
  <div>
    <div class="d-flex mb-2">
      <div class="pr-4 search noprint" style="width: 48%">
        <!-- Disponibles -->
        <!-- <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            id="search-form"
            type="search"
            v-model="input_search"
            placeholder="Buscar..."
          >
          </b-form-input>
          <b-input-group-append>
            <b-button :disabled="!input_search" @click="input_search = ''"
              >Limpiar</b-button
            >
          </b-input-group-append>
        </b-input-group> -->
        <div v-if="left_selected_user.length > 0" class="container-badge-user">
          <span class="ml-3 mr-2"> {{ $t("reusable.common.selected") }}: </span>
          <b-badge
            variant="none"
            pill
            class="badge-user mt-1 mr-1"
            v-for="selected_user in left_selected_user"
            :key="`selected-${selected_user.id}`"
            v-b-tooltip.v-secondary.noninteractive.top="
              `${selected_user.first_name} ${selected_user.last_name} ${selected_user.user_data?.identifier}`
            "
          >
            <strong>
              {{
                String(selected_user.first_name + " " + selected_user.last_name)
                  .trim()
                  .split(/\s+/)
                  .map((word) => word[0].toUpperCase())
                  .join("")
              }}
            </strong>
            <b-icon
              icon="x-lg"
              scale="1"
              variant="danger"
              style="cursor: pointer"
              v-b-tooltip.v-secondary.noninteractive.bottom="
                $t('reusable.common.removeSelected')
              "
              @click="changeSelectedAvaible(selected_user)"
            ></b-icon>
          </b-badge>
        </div>
      </div>
      <!-- <div class="search noprint ml-2" style="width: 48%">
        <b-badge
          variant="secondary"
          pill
          class="badge-user"
          style="font-size: 8pt"
          >{{ unavailable_users.length }}
        </b-badge>
        Asignados
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            id="search-form"
            type="search"
            v-model="input_search_2"
            placeholder="Buscar..."
          >
          </b-form-input>
          <b-input-group-append>
            <b-button :disabled="!input_search_2" @click="input_search_2 = ''"
              >Limpiar</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </div> -->
    </div>
    <div class="tables-container">
      <div class="table-user-available mr-1">
        <NewGenericBTable
          ref="available_table"
          :display_id="'NewGenericBTable' + key_component"
          :key="generic_table_key"
          :search_filter="true"
          :columns_display="true"
          :fields="fields"
          :pre_filter="pre_filter"
          :pre_current_page="current_page"
          :pre_multiple_search="current_tag"
          @current_page="currentPage"
          @current_tag="currentTag"
          :url="available_users_url"
          @actual_items="actualItems"
        >
          <template #head(selected)>
            <div class="d-flex text-left" v-if="filter_by_student">
              <b-checkbox
                :checked="all_selected"
                @change="checkSelectAll"
                v-b-tooltip.top.v-secondary.noninteractive="{
                  title: $t('reusable.common.selectAll'),
                  boundary: 'viewport',
                }"
              ></b-checkbox>
            </div>
          </template>
          <template #cell(selected)="row">
            <div class="d-flex">
              <b-checkbox
                class="ml-auto mr-auto"
                :checked="left_selected_user.some((x) => x.id == row.item.id)"
                @change="changeSelectedAvaible(row.item)"
              ></b-checkbox>
            </div>
          </template>
          <template #cell(name)="row">
            {{ row.item.first_name }} {{ row.item.last_name }}
          </template>
          <template #cell(egress_profile)="row">
            <span v-if="row.item.student_card">
              {{ getEgressProfileName(row.item.student_card.egress_profile) }}
            </span>
          </template>
        </NewGenericBTable>
        <!-- <b-table
          :key="selected_available.length"
          sticky-header="300px"
          :items="
            available_users.filter(
              (x) => !selected_available.map((a) => a.id).includes(x.id)
            )
          "
          tfoot-class="custom-footer"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="input_search"
          :filter-function="filterCustom"
          :per-page="per_page"
          :current-page="currentPageAvailable"
          sort-icon-left
          responsive="sm"
          small
          hover
          fixed
          noCollapse
          bordered
          :caption-top="true"
        >
          <template #cell(selected)="row">
            <div class="d-flex">
              <b-checkbox
                class="ml-auto mr-auto"
                :checked="selected_available.some((x) => x.id == row.item.id)"
                @change="changeSelectedAvaible(row.item)"
              ></b-checkbox>
            </div>
          </template>
          <template #cell(identifier)="row">
            <span>
              {{ row.item.identifier }}
            </span>
          </template>
          <template #empty>
            <h5>Sin Data</h5>
          </template>
        </b-table> -->
      </div>
      <!-- :class="{ 'top-button': sortAvailableUser.length <= 3 }" -->
      <div class="buttons-container" v-if="allows_crud">
        <b-button variant="info" @click="moveToSelected" class="mb-2" size="sm">
          <b-icon-arrow-right></b-icon-arrow-right>
        </b-button>
        <b-button variant="info" @click="moveToUnSelected" size="sm">
          <b-icon-arrow-left></b-icon-arrow-left>
        </b-button>
      </div>
      <div v-else class="mx-3"></div>
      <div class="table-user-selected ml-1">
        <GenericBTable
          :display_id="'GenericBTable_' + key_component"
          :items="users_container_right"
          :fields="fields2"
          :selection_mode="allows_crud"
          :show_pagination="true"
          :pagination="10"
          :select_mode="'range'"
          @selected="slotSelectedRight"
        >
          <template #cell(selected)="row">
            <div class="d-flex">
              <b-checkbox
                class="ml-auto mr-auto"
                :checked="right_selected_user.some((x) => x.id == row.item.id)"
                @change="changeUnselectedAvaible(row.item)"
              ></b-checkbox>
            </div>
          </template>
          <template #cell(name)="row">
            {{ row.item.first_name }} {{ row.item.last_name }}
          </template>
          <template #cell(egress_profile)="row">
            <span v-if="row.item.student_card">
              {{ getEgressProfileName(row.item.student_card.egress_profile) }}
            </span>
          </template>
        </GenericBTable>
        <!-- <b-table
          sticky-header="300px"
          :items="unavailable_users"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="input_search_2"
          :filter-function="filterCustom2"
          sort-icon-left
          responsive="sm"
          small
          hover
          fixed
          noCollapse
          bordered
          :caption-top="true"
        >
          <template #head(selected)>
            <b-form-checkbox
              v-model="select_all_unavailable"
              @change="selectAllUnavailableUsers"
            ></b-form-checkbox>
          </template>
          <template #cell(selected)="row">
            <div class="d-flex">
              <b-checkbox
                class="ml-auto mr-auto"
                :checked="selected_unavailable.some((x) => x.id == row.item.id)"
                @change="changeSelectedUnavaible(row.item)"
              ></b-checkbox>
            </div>
          </template>
        </b-table> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { groupUserUrl } from "@/utils/globals";
import { mapGetters } from "vuex";

export default {
  name: "UserListSection",
  components: {
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
  },
  props: {
    section_id: {
      type: [Number, String],
    },
    users_ids: {
      type: Array,
    },
    // filter_by_professor: {
    //   type: Boolean,
    //   default: false,
    // },
    filter_by_student: {
      type: Boolean,
      default: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    key_component: {
      type: String,
    },
    pre_filter_array: {
      type: Array,
      default() {
        return [];
      },
    },
    // Nombre del grupo al que se restringe la lista de disponibles ('ESTUDIANTES', 'PROFESORES')
    required_group_name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      input_search: "",
      input_search_2: "",
      // sortBy: "first_name",
      // sortDesc: false,
      // available_users: [],
      // selected_available: [],
      // unavailable_users: [],
      // selected_unavailable: [],
      select_all_unavailable: false,
      generic_table_key: 0,
      users_container_right: [],
      left_selected_user: [],
      right_selected_user: [],
      current_page: 1,
      current_tag: [],
      all_selected: false,
      current_users: [],
    };
  },
  computed: {
    ...mapGetters({
      users: names.USERS,
      sections: names.SECTIONS,
      egress_profiles: names.EGRESS_PROFILES,
      roles: names.ROLES,
    }),
    // sortAvailableUser() {
    //   return this.available_users.filter(
    //     (x) =>
    //       this.$filtered(x.name, this.input_search) ||
    //       this.$filtered(
    //         this.getEgressProfileName(x.egress_profile),
    //         this.input_search
    //       )
    //   );
    // },
    group_user_url() {
      return groupUserUrl(this.required_group_name);
    },
    available_users_url() {
      return this.group_user_url || "/authentication/user/";
    },
    pre_filter() {
      // Con endpoint propio del grupo, el alcance y la forma los impone la ruta.
      // Sin él se cae al listado general y hay que pedir ambas cosas por query.
      let partial_url = this.group_user_url
        ? []
        : ["picker=True", `groups__name=${this.required_group_name}`];
      // Solo se excluyen los ya asignados. La selección pendiente se ve marcada
      // en su fila, sin volver a consultar al servidor en cada clic.
      const excludedIds = this.users_container_right.map((x) => x.id);

      if (excludedIds.length > 0) {
        partial_url.push(`id__exclude__in=${excludedIds.join(",")}`);
      }

      if (this.pre_filter_array.length > 0) {
        partial_url = partial_url.concat(this.pre_filter_array);
      }
      return partial_url.join("&");
    },
    fields() {
      let list = [];
      if (this.allows_crud)
        list.push({
          key: "selected",
          label: "",
          display_column: true,
          thStyle: "width:25px",
          tdStyle: "width:25px",
        });
      if (this.filter_by_student) {
        return list.concat([
          {
            key: "selected_all",
            label: "",
            display_column: true,
            thStyle: "width:25px",
            tdStyle: "width:25px",
          },
          {
            key: "name",
            sortable: false,
            label: this.$t("reusable.common.name"),
            display_column: true,
          },
          {
            key: "user_data",
            label: this.$t("reusable.common.identifier"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.identifier : "";
            },
          },
          {
            key: "student_card",
            label: this.$t("reusable.common.cohort"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.cohort : "";
            },
          },
          {
            key: "egress_profile",
            sortable: false,
            label: this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ),
            display_column: true,
            formatter: (value) => this.getEgressProfileName(value),
          },
          {
            key: "role",
            label: this.$t("reusable.common.role"),
            sortable: false,
            display_column: false,
            thStyle: { background: "var(--primary-color) !important" },
            formatter: (value) => this.getRoleName(value),
          },
        ]);
      } else
        return list.concat([
          {
            key: "name",
            sortable: false,
            label: this.$t("reusable.common.name"),
            display_column: true,
          },
          {
            key: "user_data",
            label: this.$t("reusable.common.identifier"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.identifier : "";
            },
          },
          {
            key: "role",
            label: this.$t("reusable.common.role"),
            sortable: false,
            display_column: false,
            thStyle: { background: "var(--primary-color) !important" },
            formatter: (value) => this.getRoleName(value),
          },
        ]);
    },

    fields2() {
      let list = [];
      if (this.allows_crud)
        list.push({
          key: "selected",
          label: "",
          display_column: true,
          thStyle: "width:25px",
          tdStyle: "width:25px",
        });
      if (this.filter_by_student) {
        return list.concat([
          {
            key: "name",
            sortable: false,
            label: this.$t("reusable.common.name"),
            display_column: true,
          },
          {
            key: "user_data",
            label: this.$t("reusable.common.identifier"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.identifier : "";
            },
          },
          {
            key: "student_card",
            label: this.$t("reusable.common.cohort"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.cohort : "";
            },
          },
          {
            key: "egress_profile",
            sortable: false,
            label: this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ),
            display_column: true,
            formatter: (value) => {
              return this.getEgressProfileName(value);
            },
          },
          {
            key: "role",
            label: this.$t("reusable.common.role"),
            sortable: false,
            display_column: false,
            thStyle: { background: "var(--primary-color) !important" },
            formatter: (value) => this.getRoleName(value),
          },
        ]);
      } else
        return list.concat([
          {
            key: "name",
            sortable: false,
            label: this.$t("reusable.common.name"),
            display_column: true,
          },
          {
            key: "user_data",
            label: this.$t("reusable.common.identifier"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.identifier : "";
            },
          },
          {
            key: "role",
            label: this.$t("reusable.common.role"),
            sortable: false,
            display_column: false,
            thStyle: { background: "var(--primary-color) !important" },
            formatter: (value) => this.getRoleName(value),
          },
        ]);
    },
    // filteredUsers() {
    //   let filtered_list = this.users;
    //   if (this.filter_by_student) {
    //     filtered_list = filtered_list.filter((x) => x.is_student == true);
    //   }
    //   if (this.filter_by_professor) {
    //     filtered_list = filtered_list.filter((x) => x.is_professor == true);
    //   }
    //   let final_list = [];
    //   filtered_list.forEach((element) => {
    //     final_list.push({
    //       id: element.id,
    //       name:
    //         element.first_name || element.last_name
    //           ? (element.first_name + " " + element.last_name).trim()
    //           : element.email,
    //       egress_profile:
    //         element.student_card != null &&
    //         element.student_card.egress_profile != null
    //           ? element.student_card.egress_profile
    //           : null,
    //       identifier:
    //         element.user_data != null && element.user_data.identifier != null
    //           ? element.user_data.identifier
    //           : null,
    //       _rowVariant: "none",
    //     });
    //   });
    //   return final_list;
    // },
    section() {
      return this.sections.find((x) => x.id == this.section_id);
    },
  },
  methods: {
    actualItems(items) {
      this.current_users = items;
    },
    checkSelectAll(checked) {
      this.all_selected = checked;

      if (checked) {
        this.current_users.forEach((item) => {
          if (!this.left_selected_user.some((x) => x.id == item.id)) {
            this.left_selected_user.push(item);
          }
        });
      } else {
        this.current_users.forEach((item) => {
          const index = this.left_selected_user.findIndex(
            (x) => x.id == item.id
          );
          if (index != -1) {
            this.left_selected_user.splice(index, 1);
          }
        });
      }
      this.all_selected = false;
    },
    refreshAvailable() {
      // Refresca la tabla de disponibles sin remontarla: conserva página, búsqueda
      // y columnas, y evita el parpadeo del remonte por :key
      this.$nextTick(() => {
        const table = this.$refs.available_table;
        if (table) table.fetchData(this.current_page || 1);
        else this.generic_table_key++;
      });
    },
    changeSelectedAvaible(item) {
      const index = this.left_selected_user.findIndex((x) => x.id == item.id);
      if (index != -1) this.left_selected_user.splice(index, 1);
      else this.left_selected_user.push(item);
    },
    changeUnselectedAvaible(item) {
      const index = this.right_selected_user.findIndex((x) => x.id == item.id);
      if (index != -1) this.right_selected_user.splice(index, 1);
      else this.right_selected_user.push(item);
    },
    // filterCustom(row) {
    //   if (
    //     this.$filtered(row.name, this.input_search) ||
    //     this.$filtered(
    //       this.getEgressProfileName(row.egress_profile),
    //       this.input_search
    //     ) ||
    //     this.$filtered(row.identifier, this.input_search)
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // selectAllUnavailableUsers() {
    //   if (this.select_all_unavailable) {
    //     this.unavailable_users
    //       .filter((x) => !this.selected_unavailable.some((a) => a.id == x.id))
    //       .forEach((x) => {
    //         this.selected_unavailable.push(x);
    //       });
    //   } else {
    //     this.selected_unavailable = [];
    //   }
    // },
    // changeSelectedUnavaible(item) {
    //   const index = this.selected_unavailable.findIndex((x) => x.id == item.id);
    //   if (index != -1) this.selected_unavailable.splice(index, 1);
    //   else this.selected_unavailable.push(item);
    //   if (this.selected_unavailable.length == this.unavailable_users.length)
    //     this.select_all_unavailable = true;
    //   else this.select_all_unavailable = false;
    // },
    // filterCustom2(row) {
    //   if (
    //     this.$filtered(row.name, this.input_search_2) ||
    //     this.$filtered(
    //       this.getEgressProfileName(row.egress_profile),
    //       this.input_search_2
    //     ) ||
    //     this.selected_unavailable.some((x) => x.id == row.id) ||
    //     this.$filtered(row.identifier, this.input_search)
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    loadAssignedUsers() {
      // La sección trae a sus usuarios anidados con ?expand=, así la tabla de la
      // derecha se arma sin pedir nada a authentication/user.
      if (this.section_id && !isNaN(this.section_id)) {
        this.$store
          .dispatch(names.FETCH_SECTION, {
            section_id: this.section_id,
            expand: ["students", "professors"],
          })
          .then((section) => {
            const detail =
              (this.filter_by_student
                ? section.students_detail
                : section.professors_detail) || [];
            // Sin users_ids el padre no lleva la cuenta: valen todos los de la sección
            if (!this.users_ids) {
              this.users_container_right = detail.slice();
              this.refreshAvailable();
              return;
            }
            this.resolveAssignedUsers(detail);
          });
        return;
      }
      if (!this.users_ids || this.users_ids.length == 0) return;
      this.fetchUsersById(this.users_ids).then((users) => {
        this.users_container_right = users;
        this.refreshAvailable();
      });
    },
    resolveAssignedUsers(detail) {
      const by_id = new Map(detail.map((x) => [x.id, x]));
      const apply = () => {
        this.users_container_right = this.users_ids
          .map((id) => by_id.get(id))
          .filter(Boolean);
        this.refreshAvailable();
      };
      apply();
      // Selección sin guardar: esos usuarios todavía no están en la sección del
      // servidor, así que hay que resolverlos aparte
      const missing = this.users_ids.filter((id) => !by_id.has(id));
      if (missing.length == 0) return;
      this.fetchUsersById(missing).then((users) => {
        users.forEach((user) => by_id.set(user.id, user));
        apply();
      });
    },
    fetchUsersById(ids) {
      return this.$restful
        .GetAll(
          `/authentication/user/?picker=True&id__in=${ids.join(
            ","
          )}`
        )
        .then((results) => results);
    },
    getEgressProfileName(value) {
      const egress_profile = this.egress_profiles.find((x) => x.id == value);
      if (egress_profile) return egress_profile.name;
      return "";
    },
    getRoleName(value) {
      const rol = this.roles.find((x) => x.id == value);
      if (rol) return rol.position_name;
      return "";
    },
    // fillUserLists() {
    //   this.available_users = [];
    //   this.unavailable_users = [];
    //   this.filteredUsers.forEach((user) => {
    //     if (this.section) {
    //       if (this.section.students.find((x) => x == user.id)) {
    //         this.unavailable_users.push(user);
    //       } else if (this.section.professors.find((x) => x == user.id)) {
    //         this.unavailable_users.push(user);
    //       } else {
    //         this.available_users.push(user);
    //       }
    //     } else {
    //       this.available_users.push(user);
    //     }
    //   });
    // },
    currentPage(current_page) {
      this.current_page = current_page;
    },
    currentTag(current_tag) {
      this.current_tag = current_tag;
    },
    slotSelectedRight(rows) {
      this.right_selected_user = rows;
    },
    moveToSelected() {
      const left_selected_user = this.left_selected_user;
      left_selected_user.forEach((user, index) => {
        if (!this.users_container_right.find((x) => x.id == user.id))
          this.users_container_right.push(user);
        if (left_selected_user.length == index + 1) {
          this.left_selected_user = [];
          this.refreshAvailable();
          this.$emit("changed", this.users_container_right);
        }
      });
      // this.selected_available.forEach((element) => {
      //   this.unavailable_users.push(element);
      //   let index = this.available_users.findIndex((x) => x.id == element.id);
      //   if (index != -1) this.available_users.splice(index, 1);
      // });
      // if (this.selected_available.length > 0)
      //   this.select_all_unavailable = false;
      // this.selected_available = [];
      // this.generic_table_key++;
      // this.$emit("changed", this.unavailable_users);
    },
    moveToUnSelected() {
      const right_selected_user = this.right_selected_user;
      right_selected_user.forEach((user, index) => {
        const index_user = this.users_container_right.findIndex(
          (x) => x.id == user.id
        );
        if (index_user != -1) this.users_container_right.splice(index_user, 1);
        if (right_selected_user.length == index + 1) {
          this.right_selected_user = [];
          this.refreshAvailable();
          this.$emit("changed", this.users_container_right);
        }
      });

      // this.selected_unavailable.forEach((element) => {
      //   this.available_users.push(element);
      //   let index = this.unavailable_users.findIndex((x) => x.id == element.id);
      //   if (index != -1) this.unavailable_users.splice(index, 1);
      // });
      // this.selected_unavailable = [];
      // if (this.select_all_unavailable) this.select_all_unavailable = false;

      // this.generic_table_key++;
      // this.$emit("changed", this.unavailable_users);
    },
  },
  watch: {
    // users() {
    //   this.fillUserLists();
    // },
  },
  created() {
    this.loadAssignedUsers();
    // this.fillUserLists();
    // if (this.filter_by_student) {
    //   this.$store.dispatch(names.FETCH_USERS).then((response) => {
    //     const map_student = [
    //       ...new Set(
    //         response
    //           .filter(
    //             (x) =>
    //               x.is_student == true &&
    //               x.student_card != null &&
    //               x.student_card.egress_profile != null
    //           )
    //           .map((x) => x.student_card.egress_profile)
    //       ),
    //     ];
    //     map_student.forEach((egress_profile_id) => {
    //       this.$store.dispatch(names.FETCH_EGRESS_PROFILE, egress_profile_id);
    //     });
    //   });
    // } else {
    // this.$store.dispatch(names.FETCH_USERS);
    // }
    if (this.section_id && !isNaN(this.section_id)) {
      this.$store.dispatch(names.FETCH_SECTION, this.section_id);
    }
  },
};
</script>

<style scoped>
.per-page-container {
  display: flex;
}
.per-page-col {
  margin-top: 0.4rem;
  max-width: 190px;
}
.footer-caption {
  color: var(--secondary-color);
  font-size: 11pt;
  padding-top: 0;
  float: left;
  transform: translateX(10%);
  margin-right: -300px;
}
.tables-container {
  display: flex;
  flex-direction: row;
}
.buttons-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.top-button {
  margin-top: 5em;
}
.table-user-selected {
  width: 45%;
}
.table-user-available {
  width: 45%;
}
.container-badge-user {
  align-items: center;
}
.badge-user {
  border: 1px solid black;
  /* display: flex; */
  align-items: center;
  justify-content: center;
  font-size: 7pt;
  letter-spacing: 0.3px;
}
</style>